import React, { useContext } from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './AccordionPanel.scss';
import {
  AccordionItemContext,
  AccordionItemContextProps,
} from '../../AccordionItem/AccordionItemContext';

export interface AccordionPanelProps {
  children: React.ReactNode;
  className?: string;
  panelContentClassName?: string;
}

const AccordionPanel = ({
  children,
  className,
  panelContentClassName,
}: AccordionPanelProps) => {
  const { expanded, panelId } =
    useContext<AccordionItemContextProps>(AccordionItemContext);
  return (
    <div className={cn(s.panelContainer, className)}>
      <div
        id={panelId}
        className={cn(
          s.accordionPanel,
          expanded && s.accordionPanelExpanded,
          expanded && panelContentClassName,
          'rvnP2'
        )}
        role="tabpanel"
      >
        {children}
      </div>
    </div>
  );
};

AccordionPanel.displayName = 'AccordionPanel';
export default AccordionPanel;
